var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/* tslint:disable */
import * as React from "react";
import { hydrate } from "react-dom";
import Root from "./root";
var initialState = JSON.parse(document.getElementById("initialState").textContent);
window.__initialState = initialState;
hydrate(React.createElement(Root, __assign({}, initialState)), document.getElementById("app"));
if (module.hot) {
    module.hot.accept("./root", function () {
        var NewRoot = require("./root").default;
        hydrate(React.createElement(NewRoot, __assign({}, window.__initialState)), document.getElementById("app"));
    });
}



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/client.tsx
// module id = GAMU
// module chunks = 3